import Container from '../components/Container';
import Section from '../components/Section';
import MaterialRow from '../components/MaterialRow';
import PeopleList from '../components/PeopleList';
import {
  about,
  advisors,
  materials,
  team,
  sections
} from '../copy';

export default function Information() {
  console.log('sections:', sections.sections);
  const aboutSection = sections.sections[0];
  const teamSection = sections.sections[1];
  const advisorsSection = sections.sections[2];
  const resourcesSection = sections.sections[3];
  return (
    <main>
      <Container>
        <Section title={aboutSection?.title} subtext={aboutSection?.subtext} animatedLine className="mt-10">
          <div className="space-y-6 text-lg sm:text-xl md:text-2xl">
            {
              // support both shapes:
              // 1) { about: ["para1","para2"] }
              // 2) { about: { paragraphs: ["para1", ...] } }
              (() => {
                const aboutParagraphs = Array.isArray(about.about)
                  ? about.about
                  : (about.about && Array.isArray(about.about.paragraphs) ? about.about.paragraphs : (about.paragraphs || []));
                return aboutParagraphs.map((p, i) => (
                  <p key={i} className="fade-up text-left text-wrap w-full" style={{ animationDelay: `${420 + i * 120}ms` }}>{p}</p>
                ));
              })()
            }
          </div>
        </Section>
        <Section title={teamSection?.title} subtext={teamSection?.subtext} animatedLine className="mt-16">
          <div className="fade-up" style={{ animationDelay: '420ms' }}>
            <PeopleList people={team} />
          </div>
        </Section>
        <Section title={advisorsSection?.title} subtext={advisorsSection?.subtext} animatedLine className="mt-16">
          <div className="fade-up" style={{ animationDelay: '420ms' }}>
            <PeopleList people={advisors} />
          </div>
        </Section>
        <Section title={resourcesSection?.title} subtext={resourcesSection?.subtext} animatedLine className="mt-16">
          <div className="pb-6">
            {(materials.items || materials).map((m, i, arr) => (
              <div key={i} className="fade-up" style={{ animationDelay: `${480 + i * 120}ms` }}>
                <MaterialRow name={m.name} href={m.href} isLast={i === (arr.length - 1)} />
              </div>
            ))}
          </div>
        </Section>
      </Container>
    </main>
  );
}
